import { forwardRef } from 'react';
import MuiAvatar from '@mui/material/Avatar';
import type { AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';

/** Alias direto do MUI: nenhum default de aparência do projeto diverge do componente. */
export type AvatarProps = MuiAvatarProps;

/** Avatar do design system: mesmo tipo/ref/estrutura de pasta dos demais átomos — ver `UserMenu` (`layout/navbar/`) como uso de referência já existente. */
export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(function Avatar(props, ref) {
  return <MuiAvatar ref={ref} {...props} />;
});
